var map = {
	"./amplify_damage__passive_skill.webp": 8221,
	"./army_of_the_dead__active_skill.webp": 1505,
	"./blight__active_skill.webp": 3949,
	"./blood_lance__active_skill.webp": 1631,
	"./blood_mist__active_skill.webp": 4044,
	"./blood_surge__active_skill.webp": 1638,
	"./blood_wave__active_skill.webp": 7322,
	"./bonded_in_essence__passive_skill.webp": 686,
	"./bone_prison__active_skill.webp": 5861,
	"./bone_spear__active_skill.webp": 8102,
	"./bone_spirit__active_skill.webp": 6438,
	"./bone_splinters__active_skill.webp": 2112,
	"./bone_storm__active_skill.webp": 5329,
	"./coalesced_blood__passive_skill.webp": 3630,
	"./compound_fracture__passive_skill.webp": 5252,
	"./corpse_explosion__active_skill.webp": 1238,
	"./corpse_tendrils__active_skill.webp": 2510,
	"./crippling_darkness__passive_skill.webp": 7035,
	"./deaths_defense__passive_skill.webp": 217,
	"./deaths_embrace__passive_skill.webp": 8555,
	"./deaths_reach__passive_skill.webp": 9392,
	"./decompose__active_skill.webp": 7741,
	"./decrepify__active_skill.webp": 9820,
	"./drain_vitality__passive_skill.webp": 6949,
	"./evulsion__passive_skill.webp": 6653,
	"./fueled_by_death__passive_skill.webp": 6202,
	"./gloom__passive_skill.webp": 4574,
	"./golem_mastery__passive_skill.webp": 7334,
	"./grim_harvest__passive_skill.webp": 7434,
	"./gruesome_mending__passive_skill.webp": 1323,
	"./hellbent_commander__passive_skill.webp": 8085,
	"./hemorrhage__active_skill.webp": 6085,
	"./hewed_flesh__passive_skill.webp": 8815,
	"./imperfectly_balanced__passive_skill.webp": 370,
	"./inspiring_leader__passive_skill.webp": 2014,
	"./iron_maiden__active_skill.webp": 8488,
	"./kalans_edict__passive_skill.webp": 7260,
	"./memento_mori__passive_skill.webp": 8043,
	"./necrotic_carapace__passive_skill.webp": 9574,
	"./ossified_essence__passive_skill.webp": 3048,
	"./rapid_ossification__passive_skill.webp": 657,
	"./rathmas_vigor__passive_skill.webp": 6803,
	"./reap__active_skill.webp": 9672,
	"./reapers_pursuit__passive_skill.webp": 6244,
	"./serration__passive_skill.webp": 9958,
	"./sever__active_skill.webp": 4820,
	"./shadowblight__passive_skill.webp": 8372,
	"./skeletal_mage_mastery__passive_skill.webp": 9751,
	"./skeletal_warrior_mastery__passive_skill.webp": 4143,
	"./spiked_armor__passive_skill.webp": 4592,
	"./stand_alone__passive_skill.webp": 475,
	"./terror__passive_skill.webp": 1002,
	"./tides_of_blood__passive_skill.webp": 8143,
	"./transfusion__passive_skill.webp": 5337,
	"./unliving_energy__passive_skill.webp": 6505
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8315;